import React, { useRef, useMemo, useState } from "react";
import {
    Form, FormControl, Schema, Alert, Input, Checkbox,
    FormGroup, ControlLabel, SelectPicker
} from "rsuite";
import styled from "styled-components";

import { CustomModal } from "components/base";

const { StringType, BooleanType } = Schema.Types;


export default ({
    show = false,
    loading = false,
    referenceLoading = false,
    maxWidth = 600,
    resizedWidth,
    defaultValues = {},

    mccMncList,
    dialerList,
    supplierList,

    onClose,
    onSuccess,

    setLoading,
    handleCreateException,
    ...props
}) => {
    const formRef = useRef(null);
    const [formValue, setFormValue] = useState(defaultValues);
    const [doNotSendValue, setDoNotSendValue] = useState(defaultValues?.do_not_send || true);

    const formModel = useMemo(() => {
        // const senderFilled = !!formValue?.senderid?.trim();
        // const langFilled = !!formValue?.language?.trim();
        const supplierFilled = !!formValue?.supplier_id;

        const needSenderLang = !supplierFilled;

        return Schema.Model({
            senderid: needSenderLang
                ? StringType()
                    .isRequired("Sender ID is required when Supplier is empty")
                    .minLength(3, "Min characters 3")
                    .maxLength(40, "Max characters 40")
                : StringType()
                    .minLength(3, "Min characters 3")
                    .maxLength(40, "Max characters 40"),

            language: needSenderLang
                ? StringType()
                    .isRequired("Language is required when Supplier is empty")
                    .minLength(2, "Min characters 2")
                    .maxLength(40, "Max characters 40")
                : StringType()
                    .minLength(2, "Min characters 2")
                    .maxLength(40, "Max characters 40"),

            supplier_id: StringType(),
            mcc_mnc: StringType(),
            dialer_id: StringType(),
            not_exception: BooleanType()
        });
    }, [formValue]);


    const handleSubmit = async () => {
        if (!formRef.current.check()) {
            return;
        }

        const params = {
            ...formValue,
            do_not_send: doNotSendValue
        };

        setLoading(true);

        await handleCreateException(params)
            .then(() => {
                Alert.success("Exception created!");
                onSuccess();
            })
            .catch((error) => {
                Alert.error(error.message || "Error creating exception");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (<StyledModal
        show={show}
        showFooter={true}
        title="Add new exception"
        width={resizedWidth > maxWidth ? maxWidth : resizedWidth}
        onConfirm={handleSubmit}
        loading={loading}
        onClose={() => {
            onClose();
        }}
        onExited={() => {
            onClose();
        }}
    >
        <Form
            ref={formRef}
            model={formModel}
            formValue={formValue}
            onChange={setFormValue}
        >
            <StyledFormGroup>
                <ControlLabel>Sender ID</ControlLabel>
                <FormControl
                    accepter={Input}
                    name="senderid"
                    placeholder="Enter..."
                    style={{ width: 280 }}
                />
            </StyledFormGroup>
            <StyledFormGroup>
                <ControlLabel>Message Language</ControlLabel>
                <FormControl
                    accepter={Input}
                    name="language"
                    placeholder="Enter..."
                    style={{ width: 280 }}
                />
            </StyledFormGroup>
            <StyledFormGroup>
                <ControlLabel>Supplier</ControlLabel>
                <FormControl
                    accepter={SelectPicker}
                    data={supplierList}
                    disabled={referenceLoading}
                    loading={referenceLoading}
                    name="supplier_id"
                    labelKey="name"
                    valueKey="supplier_id"
                    placement="autoVertical"
                    placeholder="Select..."
                    style={{ width: 280 }}
                />
            </StyledFormGroup>
            <StyledFormGroup>
                <ControlLabel>Destination</ControlLabel>
                <FormControl
                    accepter={SelectPicker}
                    data={mccMncList}
                    name="mcc_mnc"
                    labelKey="nameMccMnc"
                    valueKey="mcc_mnc"
                    placement="autoVertical"
                    placeholder="Select..."
                    style={{ width: 280 }}
                />
            </StyledFormGroup>
            <StyledFormGroup>
                <ControlLabel>Dialer</ControlLabel>
                <FormControl
                    accepter={SelectPicker}
                    data={dialerList}
                    disabled={referenceLoading}
                    loading={referenceLoading}
                    name="dialer_id"
                    labelKey="name"
                    valueKey="id"
                    placement="autoVertical"
                    placeholder="Select..."
                    style={{ width: 280 }}
                />
            </StyledFormGroup>
            <StyledFormGroup>
                <ControlLabel>Do not send</ControlLabel>
                <FormControl
                    accepter={Checkbox}
                    name="do_no_send"
                    checked={doNotSendValue}
                    onChange={(_, checked) => {
                        setDoNotSendValue(checked);
                    }}
                    style={{ width: 280 }}
                />
            </StyledFormGroup>
        </Form>
    </StyledModal>);
};

const StyledModal = styled(CustomModal)`
`;

const StyledFormGroup = styled(FormGroup)`
    && {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    && .rs-control-label {
        min-width: 150px;
        margin-bottom: 0;
    }
`;